/**
 * Аналітика: GA4 і Meta Pixel вмикаються лише коли задані відповідні env-змінні
 * (VITE_GA4_ID, VITE_META_PIXEL_ID) — без них нічого не вантажиться.
 * Measurement ID та Pixel ID — публічні ідентифікатори, їх можна тримати на клієнті.
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const GA_ID = import.meta.env.VITE_GA4_ID as string | undefined;
const PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID as string | undefined;

export function initAnalytics() {
  if (GA_ID) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  }

  if (PIXEL_ID) {
    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        // eslint-disable-next-line prefer-spread
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq!('init', PIXEL_ID);
    window.fbq!('track', 'PageView');
  }
}

/** Успішно надіслана заявка з форми — головна конверсія */
export function trackLead() {
  window.gtag?.('event', 'generate_lead', { method: 'contact_form' });
  window.fbq?.('track', 'Lead');
}

export type ContactChannel = 'telegram' | 'viber' | 'whatsapp' | 'phone' | 'email';

/** Клік по месенджеру/телефону — мікроконверсія */
export function trackContactClick(channel: ContactChannel) {
  window.gtag?.('event', 'contact_click', { channel });
  window.fbq?.('trackCustom', 'ContactClick', { channel });
}
